<template>
    <div class="app-showcase" ref="root-container">
        <div class="aspect-ratio-container">
            <div class="frame"></div>
            <div class="video" v-show="shouldShowVideo">
                <div class="video-content" >
                    <video muted preload autoplay loop @click="videoClicked">
                        <source :src="videoSrc" :poster="posterSrc" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
            <div class="screen shadow">
                <img :src="imageSrc" class="screen-content">
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "app-showcase",
  props: {
    imageSrc: {
      type: String,
      required: true,
      description: "Source url of the image to show."
    },
    videoSrc: {
      type: String,
      default: null,
      description: "Source url of the video to play."
    },
    posterSrc: {
      type: String,
      default: null,
      description: "Source url of the poster image to show for the video."
    }
  },
  computed: {
    isOnMobile() {
      return false;
    },
    shouldShowVideo() {
      return !this.isOnMobile && this.videoSrc;
    }
  },
  methods: {
    videoClicked() {
      console.log("videoClicked");
    }
  }
};
</script>
<style scoped lang="css">
    
    .aspect-ratio-container {
        position: relative;
        width: 100%;
        padding-bottom: 200%;
        max-height: 100%;
    }

    .frame, 
    .video, 
    .screen {
        position: absolute;
        width: 100%;
        height: 100%;
        -webkit-mask-image: url('/img/app/iPhoneX_full_mask.png');
        mask-image: url('/img/app/iPhoneX_full_mask.png');
        -webkit-mask-size: 100%;
        mask-size: 100%;
    }

    .frame {
        z-index: 3;
        background-image: url('/img/app/iPhoneX_frame.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        -webkit-filter: drop-shadow(1px 1px 4px rgba(0,0,0,0.3));
        -moz-filter: drop-shadow(1px 1px 4px rgba(0,0,0,0.3));
        -ms-filter: drop-shadow(1px 1px 4px rgba(0,0,0,0.3));
        -o-filter: drop-shadow(1px 1px 4px rgba(0,0,0,0.3));
    }

    @media only screen and (max-width: 544px) {
        .video {
            display: none;
        }   
    }

    .video {
        z-index: 2;
        -webkit-mask-image: url('/img/app/iPhoneX_screen_mask.png');
        mask-image: url('/img/app/iPhoneX_screen_mask.png');
        -webkit-mask-size: 100%;
        mask-size: 100%;
        overflow: hidden;
        width: 100%;
        height: 100%;
    }

    .video .video-content {
        /* Note: The percentage are measurements taken from the mask image */
        margin-top: 6.0%;
        margin-bottom: 6.0%;
        margin-left: 6.5%;
        margin-right: 6.5%;
        height: 94%;
        width: 87%; 
    }

    .video .video-content video {
        /* Note: The percentage are measurements taken from the mask image */
        height: 100%;
        width: 100%;
    }

    .screen {
        z-index: 1;
        background-color: black;
        -webkit-mask-image: url('/img/app/iPhoneX_screen_mask.png');
        mask-image: url('/img/app/iPhoneX_screen_mask.png');
        -webkit-mask-size: 100%;
        mask-size: 100%;
        overflow: hidden;
        width: 100%;
        height: 100%;
    }

    .screen .screen-content {
        /* Note: The percentage are measurements taken from the mask image */
        margin-top: 6.0%;
        margin-bottom: 6.0%;
        margin-left: 6.5%;
        margin-right: 6.5%;
        height: 94%;
        width: 87%; 
        object-fit: cover;
        object-position: center;
        /* background-image: url('/img/apps/ping/ping_screen.jpeg');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center; */
    }

</style>
